import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ed70ae5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat" }

import { ref } from 'vue';
import { Input } from 'ant-design-vue';

const __default__ = { name: 'Chat' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const aTextarea = Input.TextArea;
const testtxt = ref('聊天互动仅支持更改名称');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(aTextarea), {
      class: "c_textarea chat_textarea",
      disabled: "",
      value: testtxt.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((testtxt).value = $event))
    }, null, 8, ["value"])
  ]))
}
}

})